/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
  TelegramUsersControllerGetTelegramLinkStatusPathParams,
  TelegramUsersControllerGetTelegramLinkStatus401,
  TelegramUsersControllerGetTelegramLinkStatus404,
} from '../types/TelegramUsersControllerGetTelegramLinkStatus.ts';

function getTelegramUsersGetTelegramLinkStatusUrl(id: TelegramUsersControllerGetTelegramLinkStatusPathParams['id']) {
  const res = { method: 'GET', url: `/api/telegram/users/telegram-link/${id}` as const };
  return res;
}

/**
 * {@link /api/telegram/users/telegram-link/:id}
 */
export async function telegramUsersGetTelegramLinkStatus(
  id: TelegramUsersControllerGetTelegramLinkStatusPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramUsersControllerGetTelegramLinkStatusQueryResponse,
    ResponseErrorConfig<
      TelegramUsersControllerGetTelegramLinkStatus401 | TelegramUsersControllerGetTelegramLinkStatus404
    >,
    unknown
  >({ method: 'GET', url: getTelegramUsersGetTelegramLinkStatusUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
